import axios from 'axios';
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { IAppointment, IAppointmentRequest, AppointmentUpdateStatusRequest, AppointmentUpdateGuestNameRequest, AppointmentUpdateNoteRequest, AppointmentUpdateClientIdRequest, AppointmentUpdateUserIdRequest, AppointmentUpdateDateTimeRequest, AppointmentUpdateServiceIdsRequest, AppointmentByClientIdRequest, AppointmentByUserIdRequest } from "@ontime/types";

const API_URL = (organizationId: string, serviceProviderId: string) => `${ApiURL()}/organizations/${organizationId}/serviceProvider/${serviceProviderId}/appointment`;

class AppointmentService {

    async GetList(organizationId: string, serviceProviderId: string, date: string, showDeleted: boolean = false): Promise<IAppointment[]> {
        const response = await axios.get<IAppointment[]>(API_URL(organizationId, serviceProviderId), {
            params: { date, showDeleted },
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Get(organizationId: string, serviceProviderId: string, appointmentId: string): Promise<IAppointment> {
        const response = await axios.get<IAppointment>(`${API_URL(organizationId, serviceProviderId)}/${appointmentId}`, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Create(organizationId: string, serviceProviderId: string, input: IAppointmentRequest): Promise<IAppointment> {
        const response = await axios.post<IAppointment>(API_URL(organizationId, serviceProviderId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Update(organizationId: string, serviceProviderId: string, input: IAppointmentRequest): Promise<IAppointment> {
        const response = await axios.put<IAppointment>(API_URL(organizationId, serviceProviderId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Delete(organizationId: string, serviceProviderId: string, appointmentId: string, currentIsDeleted: boolean): Promise<{ appointmentId: string }> {
        const response = await axios.delete<{ appointmentId: string }>(`${API_URL(organizationId, serviceProviderId)}/${appointmentId}`, {
            headers: AuthHeader(),
            params: { currentIsDeleted }
        });
        return response.data;
    }

    async CreateByUserId(organizationId: string, serviceProviderId: string, input: AppointmentByUserIdRequest): Promise<IAppointment> {
        const response = await axios.post<IAppointment>(`${API_URL(organizationId, serviceProviderId)}/CreateByUserId`, input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async CreateByClientId(organizationId: string, serviceProviderId: string, input: AppointmentByClientIdRequest): Promise<IAppointment> {
        const response = await axios.post<IAppointment>(`${API_URL(organizationId, serviceProviderId)}/CreateByClientId`, input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async UpdateByClientId(organizationId: string, serviceProviderId: string, input: AppointmentByClientIdRequest): Promise<IAppointment> {
        const response = await axios.put<IAppointment>(`${API_URL(organizationId, serviceProviderId)}/UpdateByClientId`, input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async UpdateStatus(organizationId: string, serviceProviderId: string, input: AppointmentUpdateStatusRequest): Promise<IAppointment> {
        const response = await axios.put<IAppointment>(`${API_URL(organizationId, serviceProviderId)}/UpdateStatus`, input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async UpdateNote(organizationId: string, serviceProviderId: string, input: AppointmentUpdateNoteRequest): Promise<IAppointment> {
        const response = await axios.put<IAppointment>(`${API_URL(organizationId, serviceProviderId)}/UpdateNote`, input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async UpdateClientId(organizationId: string, serviceProviderId: string, input: AppointmentUpdateClientIdRequest): Promise<IAppointment> {
        const response = await axios.put<IAppointment>(`${API_URL(organizationId, serviceProviderId)}/UpdateClientId`, input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async UpdateUserId(organizationId: string, serviceProviderId: string, input: AppointmentUpdateUserIdRequest): Promise<IAppointment> {
        const response = await axios.put<IAppointment>(`${API_URL(organizationId, serviceProviderId)}/UpdateUserId`, input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async UpdateDateTime(organizationId: string, serviceProviderId: string, input: AppointmentUpdateDateTimeRequest): Promise<IAppointment> {
        const response = await axios.put<IAppointment>(`${API_URL(organizationId, serviceProviderId)}/UpdateDateTime`, input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async UpdateServiceIds(organizationId: string, serviceProviderId: string, input: AppointmentUpdateServiceIdsRequest): Promise<IAppointment> {
        const response = await axios.put<IAppointment>(`${API_URL(organizationId, serviceProviderId)}/UpdateServiceIds`, input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async UpdateGuestName(organizationId: string, serviceProviderId: string, input: AppointmentUpdateGuestNameRequest): Promise<IAppointment> {
        const response = await axios.put<IAppointment>(`${API_URL(organizationId, serviceProviderId)}/UpdateGuestName`, input, {
            headers: AuthHeader(),
        });
        return response.data;
    }
}

export default new AppointmentService();